document.addEventListener('DOMContentLoaded', function() {
    const newsletterForm = document.querySelector('.newsletter-form');
    const newsletterMessage = document.querySelector('.newsletter-form__message');
    const newsletterAlertClass = document.querySelector('.newsletter-form__field-wrapper');
    const submitButton = document.getElementById('Subscribe');
  
    submitButton.addEventListener('click', function(event) {
      let emailInput = newsletterForm.querySelector('input[name="contact[email]"]');
      let email = emailInput.value.trim();
  
      if (!isValidEmail(email)) {
        event.preventDefault(); 
        newsletterMessage.textContent = "Please enter a valid email address";
        newsletterAlertClass.classList.add("error");
        newsletterMessage.classList.remove("hidden");
      }
    });
  
    function isValidEmail(email) {
      let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    }
  
    const formSubmittedSuccessfully = getUrlParameter('customer_posted') === 'true';
    const emailAlreadyRegistered = getUrlParameter('form_type') === 'customer';
  
    if (formSubmittedSuccessfully) {
      newsletterMessage.textContent = "Thank you, you’ve been signed up to the newsletter!";
      newsletterAlertClass.classList.add("success");
      newsletterMessage.classList.remove("hidden");
    } else if (emailAlreadyRegistered) {
      newsletterMessage.textContent = "This email address is already registered";
      newsletterAlertClass.classList.add("error");
      newsletterMessage.classList.remove("hidden");
    }
  });
  
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
  